// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/650fab60/" + chunkId + "." + __webpack_require__.h() + ".v650fab60.js";
};